module.exports = __webpack_public_path__ + "static/media/orange-tick-140x150.9563232a.svg";